export interface ISymbol {
    symbolName: string,
    onReelId: number,
    reelPosition: number,
    reelTargetPosition: number,
    reelId: number,
    alpha: number,
    position: PIXI.Point,
    isRemoved: boolean
}

export interface ISymbolPosition {
    reelId: number,
    startPosition: number,
    targetPosition: number
}

export enum SimpleReelModelState {
    IDLE = "IDLE",
    START = "START",
    SPIN = "SPIN",
    STOP = "STOP",
    STOPPED = "STOPPED",
    BOUNCE = "BOUNCE",
    NUDGE = "NUDGE",
}

export interface SimpleReelModelEventData {
    reel: number;
    state: SimpleReelModelState;
}